<template>
  <v-container>
    <div v-html="evaluation.task"></div>
    <br />
    <v-radio-group v-model="currentAnswer">
      <v-radio v-for="(answer, index) in evaluation.answers" :key="index" :value="answer">
        <template slot="label">
          <span v-html="answer.val"></span>
        </template>
      </v-radio>
    </v-radio-group>
    <div>
      <v-btn large color="primary" @click="sendAnswer()">Відповісти</v-btn>
    </div>
  </v-container>
</template>

<script>
import evaluationEventEnum from '@/enums/evaluationEventEnum';

export default {
  name: 'SelectAnswerEvaluation',
  props: {
    evaluation: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      currentAnswer: this.evaluation.answer,
    };
  },
  watch: {
    evaluation(evaluation) {
      this.answer = evaluation.answer;
    },
  },

  methods: {
    sendAnswer() {
      this.$emit('evaluateEvent', {
        type: evaluationEventEnum.SEND_ANSWER,
        data: {
          answer: this.currentAnswer,
        },
      });
    },
  },
};
</script>
